// import { Box, Typography } from "@mui/material";
// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   Cell,
// } from "recharts";
// import { fetchCompanyRegistrationTrends } from "../redux/slices/companyRegistrationSlice";

// const CompaniesRegistration = () => {
//   const dispatch = useDispatch();

//   // Get data from Redux store
//   const { registrationData, loading, error } = useSelector(
//     (state) => state.companyRegistration
//   );

//   // Data for bar chart (unchanged)
//   const barData = [
//     { name: "TechGiant Inc.", hires: 520 },
//     { name: "InnovaCorp", hires: 180 },
//     { name: "GlobalTech", hires: 340 },
//     { name: "NextGen Ltd.", hires: 320 },
//     { name: "FutureSoft", hires: 290 },
//   ];

//   // Fetch data from API using Redux
//   useEffect(() => {
//     dispatch(fetchCompanyRegistrationTrends());
//   }, [dispatch]);

//   // Transform API data for line chart
//   const getLineData = () => {
//     if (!registrationData || !registrationData.monthlyTrends) {
//       return [];
//     }

//     return registrationData.monthlyTrends.map((item) => ({
//       month: `${item.month} ${item.year}`,
//       registrations: item.count,
//     }));
//   };

//   // Calculate month-over-month growth percentage
//   const calculateMOMGrowth = () => {
//     if (!registrationData || !registrationData.monthlyTrends) {
//       return "0%";
//     }

//     const trends = registrationData.monthlyTrends;
//     const firstMonth = trends[0]?.count || 0;
//     const lastMonth = trends[trends.length - 1]?.count || 0;

//     if (firstMonth === 0) return "0%";

//     const growthRate = ((lastMonth - firstMonth) / firstMonth) * 100;
//     return `${growthRate >= 0 ? "+" : ""}${growthRate.toFixed(2)}%`;
//   };

//   // Colors for charts
//   const barColors = ["#3B82F6", "#10B981", "#EF4444", "#F59E0B", "#8B5CF6"];

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <Box
//           style={{
//             backgroundColor: "white",
//             padding: "12px 16px",
//             border: "1px solid #E5E7EB",
//             borderRadius: "8px",
//             boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
//             fontSize: "14px",
//             fontWeight: "500",
//           }}
//         >
//           <p style={{ margin: 0, color: "#374151" }}>
//             {`${label}: ${payload[0].value} hires`}
//           </p>
//         </Box>
//       );
//     }
//     return null;
//   };

//   const LineTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <Box
//           style={{
//             backgroundColor: "white",
//             padding: "8px 12px",
//             border: "1px solid #E5E7EB",
//             borderRadius: "6px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           <p style={{ margin: 0, fontSize: "13px", color: "#374151" }}>
//             {`${label}: ${payload[0].value} registrations`}
//           </p>
//         </Box>
//       );
//     }
//     return null;
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           padding: {
//             xs: "12px",
//             sm: "16px",
//             md: "20px",
//             lg: "24px",
//             xl: "24px",
//           },
//           marginLeft: {
//             xs: "0",
//             sm: "0",
//             md: "180px",
//             lg: "220px",
//             xl: "220px",
//           },
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "400px",
//         }}
//       >
//         <Typography>Loading registration trends...</Typography>
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box
//         sx={{
//           padding: {
//             xs: "12px",
//             sm: "16px",
//             md: "20px",
//             lg: "24px",
//             xl: "24px",
//           },
//           marginLeft: {
//             xs: "0",
//             sm: "0",
//             md: "180px",
//             lg: "220px",
//             xl: "220px",
//           },
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "400px",
//         }}
//       >
//         <Typography color="error">Error: {error}</Typography>
//       </Box>
//     );
//   }

//   const lineData = getLineData();
//   const momGrowth = calculateMOMGrowth();
//   const growthColor = momGrowth.includes("+") ? "#10B981" : "#EF4444";

//   return (
//     <Box
//       sx={{
//         padding: {
//           xs: "12px",
//           sm: "16px",
//           md: "20px",
//           lg: "24px",
//           xl: "24px",
//         },
//         marginBottom: "0",
//         marginLeft: {
//           xs: "0",
//           sm: "0",
//           md: "180px",
//           lg: "220px",
//           xl: "220px",
//         },
//         fontFamily: "Outfit",
//       }}
//     >
//       <Box
//         sx={{
//           display: "grid",
//           gridTemplateColumns: {
//             xs: "1fr",
//             sm: "1fr",
//             md: "1fr 1fr",
//             lg: "2fr 2fr",
//             xl: "2fr 2fr",
//           },
//           gap: {
//             xs: "16px",
//             sm: "20px",
//             md: "24px",
//             lg: "24px",
//             xl: "24px",
//           },
//           marginLeft: {
//             xs: "0",
//             sm: "0",
//             md: "1%",
//             lg: "1%",
//             xl: "1%",
//           },
//           marginRight: {
//             xs: "0",
//             sm: "0",
//             md: "2%",
//             lg: "2%",
//             xl: "2%",
//           },
//         }}
//       >
//         {/* Company Registration Trends Chart */}
//         <Box
//           sx={{
//             backgroundColor: "white",
//             padding: {
//               xs: "16px",
//               sm: "20px",
//               md: "24px",
//               lg: "24px",
//               xl: "24px",
//             },
//             borderRadius: "12px",
//             border: "1px solid #E5E7EB",
//             position: "relative",
//           }}
//         >
//           <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
//             <h2
//               style={{
//                 fontSize: "20px",
//                 fontWeight: "bold",
//                 color: "#111827",
//                 margin: "0 0 8px 0",
//                 textAlign: "left",
//                 fontFamily: "Outfit",
//               }}
//             >
//               Company Registration Trends
//             </h2>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 marginBottom: "12px",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: { xs: "8px", sm: "0" },
//                 alignItems: { xs: "flex-start", sm: "center" },
//                 fontFamily: "Outfit",
//                 fontWeight: 400,
//               }}
//             >
//               {/* <span style={{ fontSize: "14px", color: "#4B5563" }}>
//                 Overall Growth (MOM in{" "}
//                 {registrationData?.year || new Date().getFullYear()}):{" "}
//                 <span style={{ color: growthColor }}>-395%</span>
//               </span> */}
//             </Box>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: { xs: "8px", sm: "0" },
//                 alignItems: { xs: "flex-start", sm: "center" },
//                 fontFamily: "Outfit",
//                 color: "#4B5563",
//               }}
//             >
//               <Typography
//                 style={{ fontSize: "14px", color: "#6B7280", fontWeight: 400 }}
//               >
//                 Peak Month:{" "}
//                 <span style={{ fontWeight: 300 }}>
//                   {registrationData?.peakMonth?.month || "N/A"}
//                 </span>
//               </Typography>
//               <span style={{ fontSize: "14px", color: "#6B7280" }}>
//                 Lowest Month: {registrationData?.lowestMonth?.month || "N/A"}
//               </span>
//             </Box>
//           </Box>

//           <Box
//             sx={{
//               height: { xs: "280px", sm: "300px", md: "320px" },
//               width: "100%",
//             }}
//           >
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart
//                 data={lineData}
//                 margin={{ top: 20, right: 30, left: 20, bottom: -10 }}
//               >
//                 <CartesianGrid
//                   strokeDasharray="3 3"
//                   stroke="#F3F4F6"
//                   vertical={false}
//                 />
//                 <XAxis
//                   dataKey="month"
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   angle={-45}
//                   textAnchor="end"
//                   height={80}
//                   interval={0}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <YAxis
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   label={{
//                     value: "Number of Registrations",
//                     angle: -90,
//                     position: "insideLeft",
//                     style: {
//                       textAnchor: "middle",
//                       fontSize: "12px",
//                       fill: "#6B7280",
//                     },
//                   }}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <Tooltip content={<LineTooltip />} cursor={false} />
//                 <Line
//                   type="monotone"
//                   dataKey="registrations"
//                   stroke="#3B82F6"
//                   strokeWidth={3}
//                   dot={{ fill: "#3B82F6", strokeWidth: 2, r: 4 }}
//                   activeDot={{ r: 6, fill: "#3B82F6" }}
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           </Box>
//         </Box>

//         {/* Top Hiring Companies Chart */}
//         <Box
//           sx={{
//             backgroundColor: "white",
//             padding: {
//               xs: "16px",
//               sm: "20px",
//               md: "24px",
//               lg: "24px",
//               xl: "24px",
//             },
//             borderRadius: "12px",
//             border: "1px solid #E5E7EB",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
//             position: "relative", // Add this for overlay positioning
//           }}
//         >
//           <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
//             <h2
//               style={{
//                 fontSize: "18px",
//                 fontWeight: "600",
//                 color: "#111827",
//                 margin: "0 0 8px 0",
//                 textAlign: "left",
//               }}
//             >
//               Top Hiring Companies
//             </h2>
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: { xs: "12px", sm: "24px" },
//                 alignItems: "center",
//                 flexWrap: "wrap",
//                 flexDirection: { xs: "column", sm: "row" },
//                 alignItems: { xs: "flex-start", sm: "center" },
//               }}
//             >
//               <span style={{ fontSize: "13px", color: "#6B7280" }}>
//                 Total Hires: 1,670
//               </span>
//               <span style={{ fontSize: "13px", color: "#6B7280" }}>
//                 Top Hiring Company: TechGiant Inc.
//               </span>
//             </Box>
//           </Box>

//           <Box
//             sx={{
//               height: { xs: "280px", sm: "300px", md: "320px" },
//               width: "100%",
//               filter: "blur(3px)", // Add blur effect
//             }}
//           >
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart
//                 data={barData}
//                 margin={{ top: 20, right: 30, left: 20, bottom: -20 }}
//               >
//                 <CartesianGrid
//                   strokeDasharray="3 3"
//                   stroke="#F3F4F6"
//                   vertical={false}
//                 />
//                 <XAxis
//                   dataKey="name"
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   angle={-45}
//                   textAnchor="end"
//                   height={80}
//                   interval={0}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <CartesianGrid
//                   strokeDasharray="3 3"
//                   stroke="#F3F4F6"
//                   horizontal={false}
//                   vertical={true}
//                 />
//                 <YAxis
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   label={{
//                     value: "Number of Hires",
//                     angle: -90,
//                     position: "insideLeft",
//                     style: {
//                       textAnchor: "middle",
//                       fontSize: "12px",
//                       fill: "#6B7280",
//                     },
//                   }}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <Tooltip
//                   content={<CustomTooltip />}
//                   cursor={{ fill: "transparent" }}
//                 />
//                 <Bar
//                   dataKey="hires"
//                   radius={[25, 25, 0, 0]}
//                   stroke="#fff"
//                   strokeWidth={1}
//                   barSize={100}
//                 >
//                   {barData.map((entry, index) => (
//                     <Cell
//                       key={`cell-${index}`}
//                       fill={barColors[index]}
//                       style={{
//                         filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))",
//                       }}
//                     />
//                   ))}
//                 </Bar>
//               </BarChart>
//             </ResponsiveContainer>
//           </Box>

//           {/* Coming Soon Overlay */}
//           <Box
//             sx={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               backgroundColor: "rgba(255, 255, 255, 0.7)",
//               borderRadius: "12px",
//               zIndex: 10,
//             }}
//           >
//             <h3
//               style={{
//                 margin: "0",
//                 fontSize: "28px",
//                 fontWeight: "700",
//                 color: "#2B3674",
//                 fontFamily: "Outfit",
//                 textAlign: "center",
//                 textShadow: "0 2px 4px rgba(0,0,0,0.1)",
//               }}
//             >
//               Coming Soon
//             </h3>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default CompaniesRegistration;
// import { Box, Typography } from "@mui/material";
// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   LineChart,
//   Line,
//   Cell,
// } from "recharts";
// import { fetchCompanyRegistrationTrends } from "../redux/slices/companyRegistrationSlice";

// const CompaniesRegistration = () => {
//   const dispatch = useDispatch();

//   // Get data from Redux store
//   const { registrationData, loading, error } = useSelector(
//     (state) => state.companyRegistration
//   );

//   // Data for bar chart (unchanged)
//   const barData = [
//     { name: "TechGiant Inc.", hires: 520 },
//     { name: "InnovaCorp", hires: 180 },
//     { name: "GlobalTech", hires: 340 },
//     { name: "NextGen Ltd.", hires: 320 },
//     { name: "FutureSoft", hires: 290 },
//   ];

//   // Fetch data from API using Redux
//   useEffect(() => {
//     dispatch(fetchCompanyRegistrationTrends());
//   }, [dispatch]);

//   // Transform API data for line chart
//   const getLineData = () => {
//     if (!registrationData || !registrationData.monthlyTrends) {
//       return [];
//     }

//     return registrationData.monthlyTrends.map((item) => ({
//       month: `${item.month} ${item.year}`,
//       registrations: item.count,
//     }));
//   };

//   // Calculate month-over-month growth percentage
//   const calculateMOMGrowth = () => {
//     if (
//       !registrationData ||
//       !registrationData.monthlyTrends ||
//       registrationData.monthlyTrends.length < 2
//     ) {
//       return "0%";
//     }

//     const trends = registrationData.monthlyTrends;
//     const firstMonth = trends[0]?.count || 0;
//     const lastMonth = trends[trends.length - 1]?.count || 0;

//     if (firstMonth === 0) return "0%";

//     const growthRate = ((lastMonth - firstMonth) / firstMonth) * 100;
//     return `${growthRate >= 0 ? "+" : ""}${growthRate.toFixed(2)}%`;
//   };

//   // Calculate total registrations
//   const getTotalRegistrations = () => {
//     if (!registrationData || !registrationData.monthlyTrends) {
//       return 0;
//     }
//     return registrationData.monthlyTrends.reduce(
//       (total, item) => total + (item.count || 0),
//       0
//     );
//   };

//   // Get current year from data or fallback to current year
//   const getCurrentYear = () => {
//     if (
//       registrationData &&
//       registrationData.monthlyTrends &&
//       registrationData.monthlyTrends.length > 0
//     ) {
//       return registrationData.monthlyTrends[0].year;
//     }
//     return new Date().getFullYear();
//   };

//   // Colors for charts
//   const barColors = ["#3B82F6", "#10B981", "#EF4444", "#F59E0B", "#8B5CF6"];

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <Box
//           style={{
//             backgroundColor: "white",
//             padding: "12px 16px",
//             border: "1px solid #E5E7EB",
//             borderRadius: "8px",
//             boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
//             fontSize: "14px",
//             fontWeight: "500",
//           }}
//         >
//           <p style={{ margin: 0, color: "#374151" }}>
//             {`${label}: ${payload[0].value} hires`}
//           </p>
//         </Box>
//       );
//     }
//     return null;
//   };

//   const LineTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <Box
//           style={{
//             backgroundColor: "white",
//             padding: "8px 12px",
//             border: "1px solid #E5E7EB",
//             borderRadius: "6px",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           <p style={{ margin: 0, fontSize: "13px", color: "#374151" }}>
//             {`${label}: ${payload[0].value} registrations`}
//           </p>
//         </Box>
//       );
//     }
//     return null;
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           padding: {
//             xs: "12px",
//             sm: "16px",
//             md: "20px",
//             lg: "24px",
//             xl: "24px",
//           },
//           marginLeft: {
//             xs: "0",
//             sm: "0",
//             md: "180px",
//             lg: "220px",
//             xl: "220px",
//           },
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "400px",
//         }}
//       >
//         <Typography>Loading registration trends...</Typography>
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box
//         sx={{
//           padding: {
//             xs: "12px",
//             sm: "16px",
//             md: "20px",
//             lg: "24px",
//             xl: "24px",
//           },
//           marginLeft: {
//             xs: "0",
//             sm: "0",
//             md: "180px",
//             lg: "220px",
//             xl: "220px",
//           },
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "400px",
//         }}
//       >
//         <Typography color="error">Error: {error}</Typography>
//       </Box>
//     );
//   }

//   const lineData = getLineData();
//   const momGrowth = calculateMOMGrowth();
//   const growthColor = momGrowth.includes("+") ? "#10B981" : "#EF4444";
//   const totalRegistrations = getTotalRegistrations();
//   const currentYear = getCurrentYear();

//   return (
//     <Box
//       sx={{
//         padding: {
//           xs: "12px",
//           sm: "16px",
//           md: "20px",
//           lg: "24px",
//           xl: "24px",
//         },
//         marginBottom: "0",
//         marginLeft: {
//           xs: "0",
//           sm: "0",
//           md: "180px",
//           lg: "220px",
//           xl: "220px",
//         },
//         fontFamily: "Outfit",
//       }}
//     >
//       <Box
//         sx={{
//           display: "grid",
//           gridTemplateColumns: {
//             xs: "1fr",
//             sm: "1fr",
//             md: "1fr 1fr",
//             lg: "2fr 2fr",
//             xl: "2fr 2fr",
//           },
//           gap: {
//             xs: "16px",
//             sm: "20px",
//             md: "24px",
//             lg: "24px",
//             xl: "24px",
//           },
//           marginLeft: {
//             xs: "0",
//             sm: "0",
//             md: "1%",
//             lg: "1%",
//             xl: "1%",
//           },
//           marginRight: {
//             xs: "0",
//             sm: "0",
//             md: "2%",
//             lg: "2%",
//             xl: "2%",
//           },
//         }}
//       >
//         {/* Company Registration Trends Chart */}
//         <Box
//           sx={{
//             backgroundColor: "white",
//             padding: {
//               xs: "16px",
//               sm: "20px",
//               md: "24px",
//               lg: "24px",
//               xl: "24px",
//             },
//             borderRadius: "12px",
//             border: "1px solid #E5E7EB",
//             position: "relative",
//           }}
//         >
//           <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
//             <h2
//               style={{
//                 fontSize: "20px",
//                 fontWeight: "bold",
//                 color: "#111827",
//                 margin: "0 0 8px 0",
//                 textAlign: "left",
//                 fontFamily: "Outfit",
//               }}
//             >
//               Company Registration Trends
//             </h2>

//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 width: "100%",
//                 flexDirection: { xs: "column", sm: "row" },
//                 gap: { xs: "8px", sm: "0" },
//                 alignItems: { xs: "flex-start", sm: "center" },
//                 fontFamily: "Outfit",
//                 color: "#4B5563",
//               }}
//             >
//               <Typography
//                 style={{ fontSize: "14px", color: "#6B7280", fontWeight: 400 }}
//               >
//                 Peak Month:{" "}
//                 <span style={{ fontWeight: 300 }}>
//                   {registrationData?.peakMonth?.month || "N/A"} (
//                   {registrationData?.peakMonth?.count || 0})
//                 </span>
//               </Typography>
//               <span style={{ fontSize: "14px", color: "#6B7280" }}>
//                 Lowest Month: {registrationData?.lowestMonth?.month || "N/A"} (
//                 {registrationData?.lowestMonth?.count || 0})
//               </span>
//             </Box>
//           </Box>

//           <Box
//             sx={{
//               height: { xs: "280px", sm: "300px", md: "320px" },
//               width: "100%",
//             }}
//           >
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart
//                 data={lineData}
//                 margin={{ top: 20, right: 30, left: 20, bottom: -10 }}
//               >
//                 <CartesianGrid
//                   strokeDasharray="3 3"
//                   stroke="#F3F4F6"
//                   vertical={false}
//                 />
//                 <XAxis
//                   dataKey="month"
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   angle={-45}
//                   textAnchor="end"
//                   height={80}
//                   interval={0}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <YAxis
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   label={{
//                     value: "Number of Registrations",
//                     angle: -90,
//                     position: "insideLeft",
//                     style: {
//                       textAnchor: "middle",
//                       fontSize: "12px",
//                       fill: "#6B7280",
//                     },
//                   }}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <Tooltip content={<LineTooltip />} cursor={false} />
//                 <Line
//                   type="monotone"
//                   dataKey="registrations"
//                   stroke="#3B82F6"
//                   strokeWidth={3}
//                   dot={{ fill: "#3B82F6", strokeWidth: 2, r: 4 }}
//                   activeDot={{ r: 6, fill: "#3B82F6" }}
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           </Box>
//         </Box>

//         {/* Top Hiring Companies Chart */}
//         <Box
//           sx={{
//             backgroundColor: "white",
//             padding: {
//               xs: "16px",
//               sm: "20px",
//               md: "24px",
//               lg: "24px",
//               xl: "24px",
//             },
//             borderRadius: "12px",
//             border: "1px solid #E5E7EB",
//             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
//             position: "relative", // Add this for overlay positioning
//           }}
//         >
//           <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
//             <h2
//               style={{
//                 fontSize: "18px",
//                 fontWeight: "600",
//                 color: "#111827",
//                 margin: "0 0 8px 0",
//                 textAlign: "left",
//               }}
//             >
//               Top Hiring Companies
//             </h2>
//             <Box
//               sx={{
//                 display: "flex",
//                 gap: { xs: "12px", sm: "24px" },
//                 alignItems: "center",
//                 flexWrap: "wrap",
//                 flexDirection: { xs: "column", sm: "row" },
//                 alignItems: { xs: "flex-start", sm: "center" },
//               }}
//             >
//               <span style={{ fontSize: "13px", color: "#6B7280" }}>
//                 Total Hires: 1,670
//               </span>
//               <span style={{ fontSize: "13px", color: "#6B7280" }}>
//                 Top Hiring Company: TechGiant Inc.
//               </span>
//             </Box>
//           </Box>

//           <Box
//             sx={{
//               height: { xs: "280px", sm: "300px", md: "320px" },
//               width: "100%",
//               filter: "blur(3px)", // Add blur effect
//             }}
//           >
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart
//                 data={barData}
//                 margin={{ top: 20, right: 30, left: 20, bottom: -20 }}
//               >
//                 <CartesianGrid
//                   strokeDasharray="3 3"
//                   stroke="#F3F4F6"
//                   vertical={false}
//                 />
//                 <XAxis
//                   dataKey="name"
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   angle={-45}
//                   textAnchor="end"
//                   height={80}
//                   interval={0}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <CartesianGrid
//                   strokeDasharray="3 3"
//                   stroke="#F3F4F6"
//                   horizontal={false}
//                   vertical={true}
//                 />
//                 <YAxis
//                   tick={{ fontSize: 11, fill: "#6B7280" }}
//                   label={{
//                     value: "Number of Hires",
//                     angle: -90,
//                     position: "insideLeft",
//                     style: {
//                       textAnchor: "middle",
//                       fontSize: "12px",
//                       fill: "#6B7280",
//                     },
//                   }}
//                   axisLine={{ stroke: "#E5E7EB" }}
//                   tickLine={{ stroke: "#E5E7EB" }}
//                 />
//                 <Tooltip
//                   content={<CustomTooltip />}
//                   cursor={{ fill: "transparent" }}
//                 />
//                 <Bar
//                   dataKey="hires"
//                   radius={[25, 25, 0, 0]}
//                   stroke="#fff"
//                   strokeWidth={1}
//                   barSize={100}
//                 >
//                   {barData.map((entry, index) => (
//                     <Cell
//                       key={`cell-${index}`}
//                       fill={barColors[index]}
//                       style={{
//                         filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))",
//                       }}
//                     />
//                   ))}
//                 </Bar>
//               </BarChart>
//             </ResponsiveContainer>
//           </Box>

//           {/* Coming Soon Overlay */}
//           <Box
//             sx={{
//               position: "absolute",
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               backgroundColor: "rgba(255, 255, 255, 0.7)",
//               borderRadius: "12px",
//               zIndex: 10,
//             }}
//           >
//             <h3
//               style={{
//                 margin: "0",
//                 fontSize: "28px",
//                 fontWeight: "700",
//                 color: "#2B3674",
//                 fontFamily: "Outfit",
//                 textAlign: "center",
//                 textShadow: "0 2px 4px rgba(0,0,0,0.1)",
//               }}
//             >
//               Coming Soon
//             </h3>
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default CompaniesRegistration;

import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LineChart,
  Line,
  Cell,
} from "recharts";
import { fetchCompanyRegistrationTrends } from "../redux/slices/companyRegistrationSlice";

const CompaniesRegistration = ({ sidebarOpen = true }) => {
  const dispatch = useDispatch();

  // Get data from Redux store
  const { registrationData, loading, error } = useSelector(
    (state) => state.companyRegistration
  );

  // Data for bar chart (unchanged)
  const barData = [
    { name: "TechGiant Inc.", hires: 520 },
    { name: "InnovaCorp", hires: 180 },
    { name: "GlobalTech", hires: 340 },
    { name: "NextGen Ltd.", hires: 320 },
    { name: "FutureSoft", hires: 290 },
  ];

  // Fetch data from API using Redux
  useEffect(() => {
    dispatch(fetchCompanyRegistrationTrends());
  }, [dispatch]);

  // Transform API data for line chart
  const getLineData = () => {
    if (!registrationData || !registrationData.monthlyTrends) {
      return [];
    }

    return registrationData.monthlyTrends.map((item) => ({
      month: `${item.month} ${item.year}`,
      registrations: item.count,
    }));
  };

  // Calculate month-over-month growth percentage
  const calculateMOMGrowth = () => {
    if (
      !registrationData ||
      !registrationData.monthlyTrends ||
      registrationData.monthlyTrends.length < 2
    ) {
      return "0%";
    }

    const trends = registrationData.monthlyTrends;
    const firstMonth = trends[0]?.count || 0;
    const lastMonth = trends[trends.length - 1]?.count || 0;

    if (firstMonth === 0) return "0%";

    const growthRate = ((lastMonth - firstMonth) / firstMonth) * 100;
    return `${growthRate >= 0 ? "+" : ""}${growthRate.toFixed(2)}%`;
  };

  // Calculate total registrations
  const getTotalRegistrations = () => {
    if (!registrationData || !registrationData.monthlyTrends) {
      return 0;
    }
    return registrationData.monthlyTrends.reduce(
      (total, item) => total + (item.count || 0),
      0
    );
  };

  // Get current year from data or fallback to current year
  const getCurrentYear = () => {
    if (
      registrationData &&
      registrationData.monthlyTrends &&
      registrationData.monthlyTrends.length > 0
    ) {
      return registrationData.monthlyTrends[0].year;
    }
    return new Date().getFullYear();
  };

  // Calculate sidebar width based on state
  const sidebarWidth = sidebarOpen ? 200 : 90;

  // Colors for charts
  const barColors = ["#3B82F6", "#10B981", "#EF4444", "#F59E0B", "#8B5CF6"];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Box
          style={{
            backgroundColor: "white",
            padding: "12px 16px",
            border: "1px solid #E5E7EB",
            borderRadius: "8px",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          <p style={{ margin: 0, color: "#374151" }}>
            {`${label}: ${payload[0].value} hires`}
          </p>
        </Box>
      );
    }
    return null;
  };

  const LineTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Box
          style={{
            backgroundColor: "white",
            padding: "8px 12px",
            border: "1px solid #E5E7EB",
            borderRadius: "6px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <p style={{ margin: 0, fontSize: "13px", color: "#374151" }}>
            {`${label}: ${payload[0].value} registrations`}
          </p>
        </Box>
      );
    }
    return null;
  };

  if (loading) {
    return (
      <Box
        sx={{
          padding: {
            xs: "12px",
            sm: "16px",
            md: "20px",
            lg: "24px",
            xl: "24px",
          },
          marginLeft: {
            xs: "0",
            sm: "0",
            md: `${sidebarWidth}px`,
            lg: `${sidebarWidth}px`,
            xl: `${sidebarWidth}px`,
          },
          transition: "margin-left 0.3s ease",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "400px",
        }}
      >
        <Typography>Loading registration trends...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          padding: {
            xs: "12px",
            sm: "16px",
            md: "20px",
            lg: "24px",
            xl: "24px",
          },
          marginLeft: {
            xs: "0",
            sm: "0",
            md: `${sidebarWidth}px`,
            lg: `${sidebarWidth}px`,
            xl: `${sidebarWidth}px`,
          },
          transition: "margin-left 0.3s ease",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "400px",
        }}
      >
        <Typography color="error">Error: {error}</Typography>
      </Box>
    );
  }

  const lineData = getLineData();
  const momGrowth = calculateMOMGrowth();
  const growthColor = momGrowth.includes("+") ? "#10B981" : "#EF4444";
  const totalRegistrations = getTotalRegistrations();
  const currentYear = getCurrentYear();

  return (
    <Box
      sx={{
        padding: {
          xs: "12px",
          sm: "16px",
          md: "20px",
          lg: "24px",
          xl: "24px",
        },
        marginBottom: "0",
        marginLeft: {
          xs: "0",
          sm: "0",
          md: `${sidebarWidth}px`,
          lg: `${sidebarWidth}px`,
          xl: `${sidebarWidth}px`,
        },
        transition: "margin-left 0.3s ease",
        fontFamily: "Outfit",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr",
            md: "1fr 1fr",
            lg: "2fr 2fr",
            xl: "2fr 2fr",
          },
          gap: {
            xs: "16px",
            sm: "20px",
            md: "24px",
            lg: "24px",
            xl: "24px",
          },
          marginLeft: {
            xs: "0",
            sm: "0",
            md: "1%",
            lg: "1%",
            xl: "1%",
          },
          marginRight: {
            xs: "0",
            sm: "0",
            md: "2%",
            lg: "2%",
            xl: "2%",
          },
        }}
      >
        {/* Company Registration Trends Chart */}
        <Box
          sx={{
            backgroundColor: "white",
            padding: {
              xs: "16px",
              sm: "20px",
              md: "24px",
              lg: "24px",
              xl: "24px",
            },
            borderRadius: "12px",
            border: "1px solid #E5E7EB",
            position: "relative",
          }}
        >
          <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
            <h2
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "#111827",
                margin: "0 0 8px 0",
                textAlign: "left",
                fontFamily: "Outfit",
              }}
            >
              Company Registration Trends
            </h2>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                flexDirection: { xs: "column", sm: "row" },
                gap: { xs: "8px", sm: "0" },
                alignItems: { xs: "flex-start", sm: "center" },
                fontFamily: "Outfit",
                color: "#4B5563",
              }}
            >
              <Typography
                style={{ fontSize: "14px", color: "#6B7280", fontWeight: 400 }}
              >
                Peak Month:{" "}
                <span style={{ fontWeight: 300 }}>
                  {registrationData?.peakMonth?.month || "N/A"} (
                  {registrationData?.peakMonth?.count || 0})
                </span>
              </Typography>
              <span style={{ fontSize: "14px", color: "#6B7280" }}>
                Lowest Month: {registrationData?.lowestMonth?.month || "N/A"} (
                {registrationData?.lowestMonth?.count || 0})
              </span>
            </Box>
          </Box>

          <Box
            sx={{
              height: { xs: "280px", sm: "300px", md: "320px" },
              width: "100%",
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={lineData}
                margin={{ top: 20, right: 30, left: 20, bottom: -10 }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#F3F4F6"
                  vertical={false}
                />
                <XAxis
                  dataKey="month"
                  tick={{ fontSize: 11, fill: "#6B7280" }}
                  angle={-45}
                  textAnchor="end"
                  height={80}
                  interval={0}
                  axisLine={{ stroke: "#E5E7EB" }}
                  tickLine={{ stroke: "#E5E7EB" }}
                />
                <YAxis
                  tick={{ fontSize: 11, fill: "#6B7280" }}
                  label={{
                    value: "Number of Registrations",
                    angle: -90,
                    position: "insideLeft",
                    style: {
                      textAnchor: "middle",
                      fontSize: "12px",
                      fill: "#6B7280",
                    },
                  }}
                  axisLine={{ stroke: "#E5E7EB" }}
                  tickLine={{ stroke: "#E5E7EB" }}
                />
                <Tooltip content={<LineTooltip />} cursor={false} />
                <Line
                  type="monotone"
                  dataKey="registrations"
                  stroke="#3B82F6"
                  strokeWidth={3}
                  dot={{ fill: "#3B82F6", strokeWidth: 2, r: 4 }}
                  activeDot={{ r: 6, fill: "#3B82F6" }}
                />
              </LineChart>
            </ResponsiveContainer>
          </Box>
        </Box>

        {/* Top Hiring Companies Chart */}
        <Box
          sx={{
            backgroundColor: "white",
            padding: {
              xs: "16px",
              sm: "20px",
              md: "24px",
              lg: "24px",
              xl: "24px",
            },
            borderRadius: "12px",
            border: "1px solid #E5E7EB",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
            position: "relative", // Add this for overlay positioning
          }}
        >
          <Box sx={{ marginBottom: { xs: "16px", sm: "20px" } }}>
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#111827",
                margin: "0 0 8px 0",
                textAlign: "left",
              }}
            >
              Top Hiring Companies
            </h2>
            <Box
              sx={{
                display: "flex",
                gap: { xs: "12px", sm: "24px" },
                alignItems: "center",
                flexWrap: "wrap",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
              }}
            >
              <span style={{ fontSize: "13px", color: "#6B7280" }}>
                Total Hires: 1,670
              </span>
              <span style={{ fontSize: "13px", color: "#6B7280" }}>
                Top Hiring Company: TechGiant Inc.
              </span>
            </Box>
          </Box>

          <Box
            sx={{
              height: { xs: "280px", sm: "300px", md: "320px" },
              width: "100%",
              filter: "blur(3px)", // Add blur effect
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={barData}
                margin={{ top: 20, right: 30, left: 20, bottom: -20 }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#F3F4F6"
                  vertical={false}
                />
                <XAxis
                  dataKey="name"
                  tick={{ fontSize: 11, fill: "#6B7280" }}
                  angle={-45}
                  textAnchor="end"
                  height={80}
                  interval={0}
                  axisLine={{ stroke: "#E5E7EB" }}
                  tickLine={{ stroke: "#E5E7EB" }}
                />
                <CartesianGrid
                  strokeDasharray="3 3"
                  stroke="#F3F4F6"
                  horizontal={false}
                  vertical={true}
                />
                <YAxis
                  tick={{ fontSize: 11, fill: "#6B7280" }}
                  label={{
                    value: "Number of Hires",
                    angle: -90,
                    position: "insideLeft",
                    style: {
                      textAnchor: "middle",
                      fontSize: "12px",
                      fill: "#6B7280",
                    },
                  }}
                  axisLine={{ stroke: "#E5E7EB" }}
                  tickLine={{ stroke: "#E5E7EB" }}
                />
                <Tooltip
                  content={<CustomTooltip />}
                  cursor={{ fill: "transparent" }}
                />
                <Bar
                  dataKey="hires"
                  radius={[25, 25, 0, 0]}
                  stroke="#fff"
                  strokeWidth={1}
                  barSize={100}
                >
                  {barData.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={barColors[index]}
                      style={{
                        filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))",
                      }}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </Box>

          {/* Coming Soon Overlay */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              borderRadius: "12px",
              zIndex: 10,
            }}
          >
            <h3
              style={{
                margin: "0",
                fontSize: "28px",
                fontWeight: "700",
                color: "#2B3674",
                fontFamily: "Outfit",
                textAlign: "center",
                textShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              Coming Soon
            </h3>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CompaniesRegistration;
